import { inventoryDigitalMovementsTypes } from './types';

const {
  HANDLE_DIGITAL_MOV_INPUTS,
  GET_INVENTORIES_DIGITAL_MOV,
  DIGITAL_UPDATE_ACTION,
} = inventoryDigitalMovementsTypes;

const initialState = {
  digitalMovements: [],
};

export const inventoryDigitalMovementsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_DIGITAL_MOV_INPUTS:
      return { ...state, [payload.key]: payload.value };
    case GET_INVENTORIES_DIGITAL_MOV:
      return { ...state, digitalMovements: payload };
    case DIGITAL_UPDATE_ACTION:
      return {
        ...state,
        digitalMovements: state.digitalMovements.map((item) =>
          item.id === payload.id ? { ...item, status: payload.status } : item
        ),
      };
    default:
      return state;
  }
};
